(function() {
  if (window.__wnGa4TrackingLoaded) return;
  window.__wnGa4TrackingLoaded = true;

  var config = window.WN_GA4_CONFIG || {};
  var debug = /(?:\?|&)wn_ga4_debug=1(?:&|$)/.test(window.location.search);
  var shopDomains = [
    'wildnord.fr',
    'wildnord.se',
    'wildnord.de',
    'wildnord.nl',
    'wildnord.dk',
    'wildnord.fi',
    'wildnord.it',
    'wildnordshop.com',
    'myshopify.com'
  ];

  function truncate(value, max) {
    value = value == null ? '' : String(value);
    max = max || 100;
    return value.length > max ? value.slice(0, max) : value;
  }

  function cleanText(value) {
    return truncate(String(value || '').replace(/\s+/g, ' ').trim(), 120);
  }

  function pathHandle(prefix) {
    var match = window.location.pathname.match(prefix);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function pageType() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    if (meta && meta.pageType) return meta.pageType;
    if (/^\/blogs\//.test(window.location.pathname)) return 'article';
    if (/^\/products\//.test(window.location.pathname)) return 'product';
    if (/^\/collections\//.test(window.location.pathname)) return 'collection';
    if (/^\/search/.test(window.location.pathname)) return 'search';
    return window.location.pathname === '/' ? 'home' : 'page';
  }

  function baseParams(extra) {
    var type = pageType();
    var params = {
      page_type: type,
      page_path: truncate(window.location.pathname, 180),
      page_title: truncate(document.title, 180),
      hostname: window.location.hostname,
      locale: document.documentElement.getAttribute('lang') || '',
      article_handle: pathHandle(/^\/blogs\/[^/]+\/([^/?#]+)/),
      collection_handle: pathHandle(/^\/collections\/([^/?#]+)/),
      product_handle: pathHandle(/^\/products\/([^/?#]+)/)
    };
    Object.keys(extra || {}).forEach(function(key) {
      var value = extra[key];
      if (value !== undefined && value !== null && value !== '') params[key] = value;
    });
    return params;
  }

  function sendEvent(name, params) {
    if (!name) return;
    var payload = baseParams(params);
    payload.send_to = config.measurementId || 'G-481W5SK797';
    payload.transport_type = 'beacon';
    if (debug && window.console) console.log('[WN GA4]', name, payload);
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, wn_ga4_params: payload });
    }
  }

  function linkUrl(anchor) {
    try { return new URL(anchor.getAttribute('href'), window.location.href); }
    catch (e) { return null; }
  }

  function linkType(url) {
    if (!url) return 'unknown';
    if (url.hostname && url.hostname !== window.location.hostname) {
      var internal = shopDomains.some(function(domain) { return url.hostname === domain || url.hostname.endsWith('.' + domain); });
      return internal ? 'internal_domain' : 'outbound';
    }
    if (/^\/collections\//.test(url.pathname)) return 'collection';
    if (/^\/products\//.test(url.pathname)) return 'product';
    if (/^\/blogs\//.test(url.pathname)) return 'blog';
    if (/^\/search/.test(url.pathname)) return 'search';
    return 'internal';
  }

  function extractHandle(url, type) {
    if (!url) return '';
    var pattern = type === 'collection' ? /^\/collections\/([^/?#]+)/ :
      type === 'product' ? /^\/products\/([^/?#]+)/ :
      type === 'blog' ? /^\/blogs\/[^/]+\/([^/?#]+)/ : null;
    if (!pattern) return '';
    var match = url.pathname.match(pattern);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function positionInStrip(anchor) {
    var strip = anchor.closest('.wn-pstrip');
    if (!strip) return 0;
    var items = Array.prototype.slice.call(strip.querySelectorAll('.wn-pstrip-item'));
    return items.indexOf(anchor.closest('.wn-pstrip-item')) + 1;
  }

  function trackClicks() {
    document.addEventListener('click', function(event) {
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (!anchor) return;
      var url = linkUrl(anchor);
      var type = linkType(url);
      var params = {
        link_text: cleanText(anchor.textContent || anchor.getAttribute('aria-label') || ''),
        link_url: truncate(url ? url.href : anchor.getAttribute('href'), 240),
        link_type: type,
        target_collection_handle: anchor.getAttribute('data-wn-collection') || extractHandle(url, 'collection'),
        target_product_handle: extractHandle(url, 'product'),
        target_article_handle: anchor.getAttribute('data-wn-article') || extractHandle(url, 'blog')
      };

      if (anchor.closest('.wn-pstrip-item')) {
        sendEvent('wn_product_strip_product_click', Object.assign({}, params, {
          product_position: positionInStrip(anchor),
          product_title: cleanText((anchor.querySelector('.wn-pstrip-title') || {}).textContent),
          price_text: cleanText((anchor.querySelector('.wn-pstrip-price') || {}).textContent)
        }));
        return;
      }

      if (anchor.closest('.wn-pstrip-cta')) {
        sendEvent('wn_product_strip_cta_click', params);
        return;
      }

      if (anchor.classList.contains('wn-cta')) {
        sendEvent('wn_article_cta_click', params);
        return;
      }

      if (pageType() === 'article' && type === 'collection') {
        sendEvent('wn_article_collection_link_click', params);
        return;
      }

      if (pageType() === 'article' && type === 'product') {
        sendEvent('wn_article_product_link_click', params);
        return;
      }

      if (pageType() === 'article' && type === 'blog') {
        sendEvent('wn_article_internal_link_click', params);
        return;
      }

      if (pageType() === 'collection' && type === 'product') {
        sendEvent('wn_collection_product_click', params);
        return;
      }

      if (type === 'outbound') {
        sendEvent('wn_outbound_click', params);
      }
    }, true);
  }

  function trackProductStripViews() {
    if (!('IntersectionObserver' in window)) return;
    var seen = new WeakSet();
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35 || seen.has(entry.target)) return;
        seen.add(entry.target);
        var cta = entry.target.querySelector('.wn-pstrip-cta a[href]');
        var ctaUrl = cta ? linkUrl(cta) : null;
        sendEvent('wn_product_strip_view', {
          item_count: entry.target.querySelectorAll('.wn-pstrip-item').length,
          target_collection_handle: extractHandle(ctaUrl, 'collection'),
          cta_text: cleanText(cta ? cta.textContent : '')
        });
      });
    }, { threshold: [0.35] });

    function observeStrips() {
      document.querySelectorAll('.wn-pstrip').forEach(function(strip) {
        if (!seen.has(strip)) observer.observe(strip);
      });
    }

    observeStrips();
    new MutationObserver(observeStrips).observe(document.body, { childList: true, subtree: true });
  }

  function trackArticleScroll() {
    if (pageType() !== 'article') return;
    var thresholds = [25, 50, 75, 90];
    var sent = {};
    function check() {
      var doc = document.documentElement;
      var scrollable = Math.max(1, doc.scrollHeight - window.innerHeight);
      var percent = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
      thresholds.forEach(function(threshold) {
        if (percent >= threshold && !sent[threshold]) {
          sent[threshold] = true;
          sendEvent('wn_article_scroll', { scroll_percent: threshold });
        }
      });
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  function trackArticleEngagementTime() {
    if (pageType() !== 'article') return;
    [45, 120].forEach(function(seconds) {
      window.setTimeout(function() {
        sendEvent('wn_article_engaged_time', { engaged_seconds: seconds });
      }, seconds * 1000);
    });
  }

  function trackSearchSubmit() {
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"], input[type="search"]');
      sendEvent('wn_search_submit', {
        search_term: cleanText(input ? input.value : '')
      });
    }, true);
  }

  function trackNewsletterSubmit() {
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var hasEmail = !!form.querySelector('input[type="email"]');
      var looksNewsletter = /newsletter|contact/.test((form.getAttribute('id') || '') + ' ' + (form.getAttribute('class') || '') + ' ' + (form.getAttribute('action') || ''));
      if (hasEmail && looksNewsletter) {
        sendEvent('wn_newsletter_submit', {
          form_id: truncate(form.getAttribute('id') || '', 80),
          form_action: truncate(form.getAttribute('action') || '', 160)
        });
      }
    }, true);
  }

  function trackCollectionControls() {
    if (pageType() !== 'collection') return;
    document.addEventListener('change', function(event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('select, input[type="checkbox"], input[type="radio"], input[type="range"]')) return;
      sendEvent('wn_collection_control_change', {
        control_name: truncate(target.getAttribute('name') || target.getAttribute('aria-label') || target.id || '', 100),
        control_value: truncate(target.value || target.getAttribute('value') || '', 100),
        control_type: truncate(target.type || target.tagName.toLowerCase(), 40),
        checked: target.checked ? 'true' : 'false'
      });
    }, true);
  }

  function trackProductOptions() {
    if (pageType() !== 'product') return;
    document.addEventListener('change', function(event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('select, input[type="radio"], input[type="checkbox"]')) return;
      if ((target.getAttribute('name') || '').toLowerCase().indexOf('quantity') !== -1) return;
      sendEvent('wn_product_option_change', {
        option_name: truncate(target.getAttribute('name') || target.getAttribute('aria-label') || target.id || '', 100),
        option_value: truncate(target.value || target.getAttribute('value') || '', 100),
        option_type: truncate(target.type || target.tagName.toLowerCase(), 40),
        checked: target.checked ? 'true' : 'false'
      });
    }, true);
  }

  function init() {
    trackClicks();
    trackProductStripViews();
    trackArticleScroll();
    trackArticleEngagementTime();
    trackSearchSubmit();
    trackNewsletterSubmit();
    trackCollectionControls();
    trackProductOptions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
